var initForm = function() {
  var $form = $('#new_prospective_user');
  var $email = $('#prospective_user_email');

  $email.tooltip({
    title: Kadenze.I18n.t('footer.form.error.email_required'),
    placement: 'top',
    trigger: 'manual'
  });

  $email.on('keyup', function(){
    $email.tooltip('hide');
  });

  $form.submit(function() {
    if ($form[0].checkValidity()) {
      $('.js-footerForm_title').text(Kadenze.I18n.t('footer.form.success.title'));
      $('.js-footerForm_p').text(Kadenze.I18n.t('footer.form.success.copy'));
      $('.js-footerForm_input_container').hide();
    } else {
      $email.tooltip('show');
    }
  });
};

export default {
  init: function() {
    initForm();
  }
};